import * as React from "react";
import { useMemo } from "react";
import * as Immutable from "immutable";
import useFieldTypes from "data-lake/hooks/useFieldTypes";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
const FieldTypesProvider = ({ children }) => {
  const { data: fieldTypes } = useFieldTypes();
  const fieldTypesContextValue = useMemo(
    () => {
      var _a;
      return {
        all: (_a = Immutable.List(fieldTypes)) != null ? _a : Immutable.List(),
        currentQuery: Immutable.List()
      };
    },
    [fieldTypes]
  );
  return /* @__PURE__ */ React.createElement(FieldTypesContext.Provider, { value: fieldTypesContextValue }, children);
};
export default FieldTypesProvider;
